import { useAuth } from '../lib/useAuth.jsx';
import './AdminNoAccess.css';

// AdminNoAccess — shown when a user signs in successfully but
// has no admin role:
//   - Not the super-admin
//   - No communities have `contact_email` matching their address
//
// Most likely cause: their email was typed wrong when their
// community was set up, or they were given the wrong email. We
// tell them to contact their Quiltt rep rather than guessing.
export default function AdminNoAccess() {
  const { user, logout } = useAuth();

  return (
    <div className="container no-access">
      <span className="eyebrow fade-in-1">Sign-In Successful</span>

      <h1 className="no-access-title fade-in-2">
        We can't find a community for <em>this email</em>.
      </h1>

      <p className="no-access-lede fade-in-3">
        You're signed in as <strong>{user?.email}</strong>, but this
        email isn't currently associated with any community in our
        system.
      </p>

      <div className="no-access-card fade-in-4">
        <h2 className="no-access-card-title">What to do next</h2>
        <ul className="no-access-steps">
          <li>
            Confirm you used the same email address that was used
            when your community was set up.
          </li>
          <li>
            If you've recently changed email addresses, your Quiltt
            contact will need to update your community's record.
          </li>
          <li>
            Otherwise, reach out to your Quiltt contact and they can
            confirm the right email or set up access for you.
          </li>
        </ul>
      </div>

      <button type="button" className="btn btn-secondary no-access-signout" onClick={logout}>
        Sign out
      </button>
    </div>
  );
}
